import React from 'react';

const Visa = ({
  width = 54,
  height = 18,
  id,
}: {
  width?: number;
  height?: number;
  id?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 54 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={id}
  >
    <path
      d="M23.816 17.255H19.5L22.2.798h4.315l-2.7 16.457ZM39.458 1.2c-.851-.332-2.201-.7-3.87-.7-4.262 0-7.262 2.24-7.28 5.444-.036 2.364 2.148 3.677 3.781 4.465 1.67.805 2.237 1.33 2.237 2.049-.017 1.102-1.349 1.61-2.591 1.61-1.723 0-2.646-.262-4.049-.875l-.568-.263-.604 3.694c1.012.455 2.877.858 4.813.876 4.527 0 7.475-2.206 7.51-5.62.017-1.873-1.136-3.309-3.622-4.482-1.51-.753-2.434-1.26-2.434-2.03.018-.701.782-1.419 2.486-1.419a7.42 7.42 0 0 1 3.214.63l.39.175.587-3.553ZM45.193 11.425c.355-.946 1.722-4.605 1.722-4.605-.018.035.355-.963.568-1.575l.302 1.418s.817 3.939.994 4.762h-3.586ZM50.519.798H47.18c-1.029 0-1.811.298-2.255 1.366l-6.41 15.09h4.528l.906-2.468h5.54c.124.578.515 2.468.515 2.468H54L50.519.798ZM15.896.798 11.671 12.02l-.462-2.276c-.781-2.626-3.232-5.48-5.966-6.898l3.87 14.391h4.564L20.459.798h-4.563Z"
      fill="#00579F"
    />
    <path
      d="M7.747.798H.804l-.07.333c5.415 1.365 9.001 4.657 10.475 8.614l-1.51-7.563C9.452 1.13 8.689.832 7.748.798Z"
      fill="#FAA61A"
    />
  </svg>
);

export default Visa;
